import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./service-formula-scheme.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./service-formula-scheme.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";
import {
  loadFormulaPayableSchemes,
  upsertFormulaPayableSchemes
} from "../formula-payable-scheme/formula-payable-scheme.actions";



@Injectable()
export class ServiceFormulaSchemeEffects {

  createServiceFormulaScheme$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createServiceFormulaSchemes),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_FORMULA_SCHEME,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceFormulaScheme({ serviceFormulaScheme: result?.data }));
              this.store.dispatch(upsertFormulaPayableSchemes({ formulaPayableSchemes: result?.data.formularPayableItems }))
              await this.notificationService.successMessage('Created Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  updateServicePercentageScheme$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.editServiceFormulaSchemes),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_FORMULA_SCHEME,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceFormulaScheme({ serviceFormulaScheme: result?.data }));
              await this.notificationService.successMessage('Updated Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getServiceFormulaSchemes$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServiceFormulaSchemes),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_FORMULA_SCHEME,
        fetchPolicy: 'network-only',
        variables: {
          billingUniqueId: action.billingUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching billing formula based details'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceFormulaSchemes({ serviceFormulaSchemes: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  citizenGetInstitutionServiceFormulaBasedSchemes$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetInstitutionServiceFormulaBasedSchemes),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.CITIZEN_GET_INSTITUTION_SERVICE_FORMULA_BASED_SCHEME,
        fetchPolicy: 'network-only',
        variables: {
          billingUniqueId: action.billingUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching billing formula based details'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(
              fromActions.loadServiceFormulaSchemes({ serviceFormulaSchemes: result?.data })
            ) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
